import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Icon, Button } from "semantic-ui-react";
import _ from "lodash";
import DatePicker from "react-datepicker";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroller";
import { Form } from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import FilterLookup from "../FilterLookup";
import "../DateField/test.css";
import ReactModal from "react-modal";
import { Loader } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import * as AppActions from "../../actions";
import NotificationItem from "../NotificationItem";
const uuidv4 = require("uuid/v1");

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: this.props.isLoading,
      from_value: "",
      to_value: "",
      notifications: [],
      showNotifications: false,
      filter_user_id: "",
      filter_form_id: "",
      current_page: 1,
      numPages: 0,
      hasMore: true
    };

    this.loading = false;
  }
  handleSetSidebarVisibility(visibility, e) {
    this.props.setSidebarVisibility(!visibility);
  }

  handleSort(value, e) {
    this.props.onSort(value);
  }

  handleClose() {
    this.props.onCloseModal();
  }

  renderRight() {
    const { formVersion, formTitle, modal } = this.props;

    if (modal) {
      return (
        <Icon
          type="MaterialIcons"
          onClick={this.handleClose.bind(this)}
          style={{ color: "#f7f7f7", cursor: "pointer" }}
          size="large"
          name="close"
        />
      );
    }

    if (
      (formVersion !== undefined && formVersion !== "") ||
      formTitle === "Settings" ||
      formTitle === "Sent" ||
      formTitle === "Approvals" ||
      formTitle === "Outbox"
    ) {
      return <span style={{ display: "inline-block", width: "29px" }}></span>;
    }

    if (this.props.isLoading && this.state.refresh) {
      return (
        <Icon
          name="refresh"
          id="loading"
          style={{ color: "#f7f7f7", cursor: "pointer" }}
          size="large"
        />
      );
    }

    return (
      <Icon
        name="refresh"
        style={{ color: "#f7f7f7", cursor: "pointer" }}
        size="large"
        onClick={this.handleRefresh.bind(this)}
      />
    );
  }

  componentWillMount() {
    const { actions, isConnected } = this.props;

    if (
      (isConnected && this.props.notifications.length === 0) ||
      this.props.pageRefresh
    ) {
      actions.getNotifications(1, this.props.filterUnread);
    } else {
      this.setState({ notifications: this.props.notifications });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    let storeId = this.props.storeId;
    let test = this.props.test;

    let pendingItems = _.filter(nextProps.actionQueue, function(item) {
      return (
        item.storeId === storeId &&
        item.test === test &&
        (item.isJob === undefined || !item.isJob)
      );
    });

    let previousItems = _.filter(this.props.actionQueue, function(item) {
      return (
        item.storeId === storeId &&
        item.test === test &&
        (item.isJob === undefined || !item.isJob)
      );
    });

    const different =
      pendingItems !== previousItems ||
      this.props.alert !== nextProps.alert ||
      this.props.filterUnread !== nextProps.filterUnread ||
      this.state.from_value !== nextState.from_value ||
      this.state.to_value !== nextState.to_value ||
      this.props.isNotificationsLoading !== nextProps.isNotificationsLoading ||
      this.props.isLoading !== nextProps.isLoading ||
      this.props.sort !== nextProps.sort ||
      this.state.showNotifications !== nextState.showNotifications ||
      this.props.notifications !== nextProps.notifications ||
      this.props.isConnected !== nextProps.isConnected ||
      this.state.hasMore !== nextState.hasMore ||
      this.state.numPages !== nextState.numPages ||
      this.state.notifications !== nextState.notifications;

    if (different && this.props.notifications !== nextProps.notifications) {
      if (nextProps.notifications.length > 0 || this.state.current_page === 1) {
        if (this.state.current_page === 1) {
          this.setState({
            current_page: this.state.current_page + 1,
            hasMore: nextProps.notifications.length < 10 ? false : true,
            notifications: nextProps.notifications
          });
        } else {
          this.setState({
            current_page: this.state.current_page + 1,
            notifications: [
              ...this.state.notifications,
              ...nextProps.notifications
            ]
          });
        }
      } else {
        this.setState({ hasMore: false });
      }
    } else {
      if (nextProps.notifications.length === 0 && !this.props.isConnected) {
        this.props.actions.getNotifications(1, this.props.filterUnread);
      } else {
        if (!this.props.isConnected) {
        } else {
          if (this.props.filterUnread !== nextProps.filterUnread) {
            this.props.actions.getNotifications(1, nextProps.filterUnread);
            this.setState({ current_page: 1 });
          }
        }
      }
    }

    return different;
  }

  handleNewForm() {
    this.props.onCopySent(
      this.props.result_id,
      this.props.formTitle,
      this.props.formId,
      this.props.formVersion,
      this.props.dateAdded
    );
  }

  handleClick(e) {
    this.props.onBack();
  }

  renderBell() {
    if (this.props.alert) {
      return (
        <i
          onClick={() => {
            this.setState({ showNotifications: !this.state.showNotifications });
          }}
          style={{
            position: "absolute",
            top: "14px",
            left: "50px",
            color: "#f7f7f7",
            cursor: "pointer"
          }}
          class="material-icons"
        >
          notifications_active
        </i>
      );
    }

    return (
      <i
        onClick={() => {
          this.setState({ showNotifications: !this.state.showNotifications });
        }}
        style={{
          position: "absolute",
          top: "14px",
          left: "50px",
          cursor: "pointer"
        }}
        class="material-icons bell"
      >
        notifications
      </i>
    );
  }

  renderNavigation() {
    const { sidebarVisibility, modal, formVersion } = this.props;

    if (modal) {
      if (formVersion !== undefined && this.props.dateAdded !== undefined) {
        return (
          <td style={{ paddingLeft: "46px" }}>
            <div
              onClick={this.handleNewForm.bind(this)}
              style={{
                color: "#f7f7f7",
                textDecoration: "underline",
                left: 20,
                top: 15,
                position: "absolute",
                cursor: "pointer"
              }}
            >
              Open as new form
            </div>
          </td>
        );
      }
      return (
        <td style={{ paddingLeft: "17px" }}>
          <Icon
            style={{
              color: "#f7f7f7",
              visibility: "hidden",
              cursor: "pointer"
            }}
            size="large"
            name="arrow left"
          />
        </td>
      );
    }

    if (this.props.login) {
      return (
        <td style={{ paddingLeft: "17px" }}>
          <Icon
            style={{
              cursor: "pointer",
              visibility: "hidden",
              height: "45px",
              color: "#f7f7f7"
            }}
            name="bars"
          />
        </td>
      );
    }

    if (this.props.backLink !== undefined) {
      return (
        <td style={{ paddingLeft: "17px" }}>
          <Icon
            onClick={this.handleClick.bind(this)}
            style={{ color: "#f7f7f7", cursor: "pointer" }}
            size="large"
            name="arrow left"
          />
        </td>
      );
    }
    let storeId = this.props.storeId;
    let test = this.props.test;
    let element = _.filter(this.props.actionQueue, function(q) {
      return q.draftName !== "" && q.storeId === storeId && q.test === test;
    });

    if (element.length > 0) {
      return (
        <td style={{ paddingLeft: "17px" }}>
          <div>
            <Icon
              size="large"
              style={{ cursor: "pointer", color: "#f7f7f7" }}
              name="bars"
              onClick={this.handleSetSidebarVisibility.bind(
                this,
                sidebarVisibility
              )}
            />
            <Icon
              name="circle"
              color="red"
              style={{
                cursor: "pointer",
                zIndex: 10,
                position: "absolute",
                left: 28,
                top: 8,
                fontSize: "16px"
              }}
              onClick={this.handleSetSidebarVisibility.bind(
                this,
                sidebarVisibility
              )}
            />
            {this.renderBell()}
          </div>
        </td>
      );
    }

    return (
      <td style={{ paddingLeft: "17px" }}>
        <Icon
          size="large"
          style={{ cursor: "pointer", color: "#f7f7f7" }}
          name="bars"
          onClick={this.handleSetSidebarVisibility.bind(
            this,
            sidebarVisibility
          )}
        />
        {this.renderBell()}
      </td>
    );
  }

  handleRefresh() {
    this.setState({ refresh: true });
    this.props.onRefresh();
  }

  search() {
    let from = "1900-01-01";
    if (this.state.from_value !== "") {
      from = moment(this.state.from_value, "DD/MM/YYYY").format("YYYY-MM-DD");
    }

    let to = "2200-01-01";
    if (this.state.to_value !== "") {
      to = moment(this.state.to_value, "DD/MM/YYYY").format("YYYY-MM-DD");
    }

    this.props.onSearch(
      from,
      to,
      this.state.filter_user_id,
      this.state.filter_form_id
    );
  }

  handleFilter(val, id) {
    this.setState({ ["filter_" + val + "_id"]: id });
    setTimeout(() => {
      this.search();
    }, 0);
  }

  handleDateChange(val, date) {
    var fDate = moment(date, "DD-MM-YYYY").format("DD/MM/YYYY");
    this.setState({ [val + "_value"]: fDate });
  }

  clearFilters() {
    this.setState({
      filter_user_id: "",
      filter_form_id: "",
      from_value: "",
      to_value: ""
    });
    setTimeout(() => {
      this.search();
    }, 0);
  }

  renderClear() {
    if (
      this.state.filter_user_id === "" &&
      this.state.filter_form_id === "" &&
      this.state.from_value === "" &&
      this.state.to_value === ""
    ) {
      return null;
    }
    return (
      <div
        onClick={this.clearFilters.bind(this)}
        style={{
          color: "white",
          bottom: 9,
          fontSize: 13,
          cursor: "pointer",
          textDecoration: "underline",
          right: 3,
          position: "relative",
          float: "right"
        }}
      >
        Clear Filters
      </div>
    );
  }

  renderSearch() {
    const { formTitle } = this.props;

    if (formTitle === "Sent") {
      return (
        <tr>
          <td colspan="3" style={{ textAlign: "center" }}>
            <div
              className="ui form"
              style={{ top: "-10px", paddingTop: "0px" }}
            >
              <div
                style={{
                  height: 40,
                  marginTop: 10,
                  flexDirection: "row",
                  justifyContent: "center",
                  width: "100%"
                }}
              >
                <FilterLookup
                  filter_type="user"
                  selectedValue={this.state.filter_user_id}
                  onSelect={this.handleFilter.bind(this)}
                ></FilterLookup>
                <FilterLookup
                  filter_type="form"
                  selectedValue={this.state.filter_form_id}
                  onSelect={this.handleFilter.bind(this)}
                ></FilterLookup>
                <div
                  style={{
                    marginLeft: "10px",
                    verticalAlign: "top",
                    display: "inline-block"
                  }}
                  className="formControlItem"
                >
                  <Form.Field>
                    <DatePicker
                      ref="ddd1"
                      className="cdc"
                      selected={
                        this.state.from_value === ""
                          ? null
                          : moment(this.state.from_value, "DD/MM/YYYY")
                      }
                      onChange={this.handleDateChange.bind(this, "from")}
                      peekNextMonth
                      placeholderText="Date From"
                      dateFormat="DD/MM/YYYY"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </Form.Field>
                </div>{" "}
                <div
                  style={{
                    marginLeft: "10px",
                    verticalAlign: "top",
                    display: "inline-block"
                  }}
                  className="formControlItem"
                >
                  <Form.Field>
                    <DatePicker
                      ref="ddd2"
                      className="cdc"
                      selected={
                        this.state.to_value === ""
                          ? null
                          : moment(this.state.to_value, "DD/MM/YYYY")
                      }
                      onChange={this.handleDateChange.bind(this, "to")}
                      peekNextMonth
                      placeholderText="Date To"
                      dateFormat="DD/MM/YYYY"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </Form.Field>
                  {this.renderClear()}
                </div>
                <Button
                  className="ui active sort button"
                  style={{
                    marginLeft: "12px",
                    display: "inline-block",
                    height: "40px",
                    width: "46px",
                    position: "relative"
                  }}
                  icon
                  onClick={this.search.bind(this)}
                >
                  <Icon className="s" name="search" />
                </Button>
              </div>
            </div>
          </td>
        </tr>
      );
    }
  }

  renderSortButtons() {
    const { formTitle, sort } = this.props;

    let sortNameCss = "ui button sort";
    let sortDateCss = "ui button sort";

    switch (sort) {
      case "form_title":
        sortNameCss = "ui button sort active";
        break;
      case "date_added":
        sortDateCss = "ui button sort active";
        break;
    }

    if (formTitle === "Forms") {
      return (
        <tr style={{ height: "52px" }}>
          <td colSpan="3" style={{ textAlign: "center", verticalAlign: "top" }}>
            <div>
              <Button
                className={sortNameCss}
                onClick={this.handleSort.bind(this, "form_title")}
                role="button"
              >
                Sort By Name
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button
                className={sortDateCss}
                onClick={this.handleSort.bind(this, "date_added")}
                role="button"
              >
                Sort By Date
              </Button>
            </div>
          </td>
        </tr>
      );
    }
  }

  renderVersion() {
    const { formVersion } = this.props;

    if (formVersion !== undefined && formVersion !== "") {
      return <span style={{ fontSize: "14px" }}>(v{formVersion})</span>;
    }

    return <span></span>;
  }

  renderTitle() {
    const { formTitle } = this.props;
    let x = this.props;

    if (this.props.backLink === "/forms" && this.props.preview === undefined) {
      return (
        <td
          width={"100%"}
          style={{
            paddingLeft: 187,
            textAlign: "center",
            color: "#f7f7f7",
            fontSize: "1.2em",
            fontWeight: "bold"
          }}
        >
          {formTitle} {this.renderVersion()}
        </td>
      );
    }

    return (
      <td
        width={"100%"}
        style={{
          textAlign: "center",
          color: "#f7f7f7",
          fontSize: "1.2em",
          fontWeight: "bold"
        }}
      >
        {formTitle} {this.renderVersion()}
      </td>
    );
  }

  handleNotificationsClose() {
    this.setState({ showNotifications: false });
  }

  handleNotificationClick(form_id, id, read) {
    this.setState({ showNotifications: false, notifications: [] });
    if (!read) {
      this.props.actions.readNotification(id);
    }
    let uuid = uuidv4();
    let recovered = false;
    let result_id;
    let notification_id = id;


    let thisForm = _.filter(this.props.forms, function(form) {
      return Number(form.form_id) === Number(form_id);
    });

    if (thisForm.length === 0) {
      const options = {
        title: "Notification",
        message: "This is a new form, or it no longer exists. Please refresh forms and try again.",
        buttons: [
          {
            label: "OK",
            onClick: () => {}
          }
        ]
      };

      confirmAlert(options);
    } else {
      thisForm = thisForm[0];
      this.props.history.push(
        `/form/${form_id}/${uuid}/${false}/${recovered}/${thisForm.form_title}/${thisForm.form_version}/${result_id}/${notification_id}`
      );
    }
  }

  renderNotificationItems() {
    var notifications = [];

    let notificationsOrdered = _.sortBy(this.state.notifications, function(n) {
      return new Date(n.dateAdded);
    }).reverse();

    notificationsOrdered.forEach((notification, index) => {
      notifications.push(
        <NotificationItem
          onClick={this.handleNotificationClick.bind(this)}
          notification={notification}
          key={index}
        ></NotificationItem>
      );
    });

    if (
      (this.props.isNotificationsLoading && this.state.current_page === 1) ||
      ((this.state.hasMore || this.state.current_page === 1) &&
        this.props.total !== -1 &&
        this.props.isConnected &&
        this.props.total > 10)
    ) {
      notifications.push(
        <div className="notification formSectionContainer">
          <form className="ui form">
            <Loader active size="medium" inline="centered">
              Loading
            </Loader>
          </form>
        </div>
      );
    }

    return <div style={{ textAlign: "left" }}>{notifications}</div>;
  }

  getListOfNotifications = () => {
    if (this.loading || !this.state.hasMore || !this.props.isConnected) {
      return;
    }
    this.props.actions.getNotifications(
      this.state.current_page,
      this.props.filterUnread
    );
  };
  handleNotificationFilter() {
    this.props.actions.setFilterUnread(!this.props.filterUnread);
    this.setState({ notifications: [] });
  }
  renderNotifications() {
    if (!this.state.showNotifications) {
      return null;
    }

    let hx = window.innerHeight - 140;

    return (
      <ReactModal
        isOpen={this.state.showNotifications}
        style={customStylesNotifications}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <div
          style={{
            paddingTop: 10,
            backgroundColor: "#f7f7f7",
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: 6,
            width: "100%",
            height: "100%"
          }}
        >
          <div style={{ textAlign: "center", height: "70px" }}>
            Notifications
            <hr
              style={{
                padding: "0px",
                marginBottom: "0px",
                width: "95%",
                border: ".5px solid #e6e6e6"
              }}
            />
            <span
              onClick={this.handleNotificationFilter.bind(this)}
              style={{
                paddingLeft: 34,
                float: "left",
                lineHeight: "40px",
                cursor: "pointer",
                textDecoration: "underline"
              }}
            >
              {this.props.filterUnread ? "Filter by Unread" : "View All"}
            </span>
          </div>
          <Icon
            type="MaterialIcons"
            onClick={this.handleNotificationsClose.bind(this)}
            style={{
              position: "absolute",
              right: "8px",
              top: "8px",
              color: "#cfcfcf",
              cursor: "pointer"
            }}
            size="large"
            name="close"
          />
          <div className="ss" style={{ maxHeight: hx, overflowY: "auto" }}>
            <InfiniteScroll
              useWindow={false}
              initialLoad={false}
              threshold={50}
              pageStart={0}
              loadMore={this.getListOfNotifications.bind(this)}
              hasMore={true}
            >
              <div
                style={{
                  display: "block",
                  textAlign: "center",
                  marginBottom: 0
                }}
                className="formSectionContainerX"
              >
                <form
                  className="notification ui formList"
                  style={{
                    display: "block",
                    minHeight: "240px",
                    padding: "30px"
                  }}
                >
                  {this.renderNotificationItems()}
                </form>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </ReactModal>
    );
  }

  render() {
    return (
      <div>
        {this.renderNotifications()}
        <table
          width={"100%"}
          className="MainHeader"
          border={0}
          cellPadding={0}
          cellSpacing={0}
        >
          <tbody>
            <tr style={{ height: "50px" }}>
              {this.renderNavigation()}
              {this.renderTitle()}
              <td style={{ paddingRight: "17px" }}>{this.renderRight()}</td>
            </tr>
            {this.renderSortButtons()}
            {this.renderSearch()}
          </tbody>
        </table>
      </div>
    );
  }
}

const customStylesNotifications = {
  content: {
    top: "55px",
    width: "85%",
    maxWidth: "400px",
    left: "5px",
    right: "auto",
    bottom: "auto",
    padding: "0px;",
    border: "0px",
    borderRadius: "5px",
    boxShadow: "0 8px 16px -4px rgba(9,30,66,.25), 0 0 0 1px rgba(9,30,66,.08)",
    minHeight: "320px",
    backgroundColor: "#f7f7f7"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)"
  }
};

Header.propTypes = {
  setSidebarVisibility: PropTypes.func,
  backLink: PropTypes.string,
  login: PropTypes.bool,
  formTitle: PropTypes.string.isRequired,
  formVersion: PropTypes.string,
  onSort: PropTypes.func,
  login: PropTypes.bool,
  onBack: PropTypes.func
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility,
  actionQueue: state.informedWebApp.actionQueue,
  storeId: state.informedWebApp.storeId,
  isConnected: state.informedWebApp.isConnected,
  pageRefresh: state.informedWebApp.pageRefresh,
  notifications: state.notifications.data,
  isNotificationsLoading: state.notifications.isLoading,
  filterUnread: state.notifications.filterUnread,
  forms: state.forms.data,
  alert: state.notifications.alert,
  total: state.notifications.total,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  isLoading: state.informedWebApp.isLoading
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/Header/index.js